export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B'
  
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i]
}

export const formatDate = (date: string | Date): string => {
  const d = new Date(date)
  return d.toLocaleDateString('zh-TW', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

export const formatDateTime = (date: string | Date): string => {
  const d = new Date(date)
  return d.toLocaleDateString('zh-TW', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const formatDateTimeWithSeconds = (date: string | Date): string => {
  const d = new Date(date)
  return d.toLocaleString('zh-TW', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })
}

// 處理圖片 URL，將相對路徑轉換為完整 URL
export const getImageUrl = (imagePath: string | null | undefined): string | null => {
  if (!imagePath) return null
  
  // 如果已經是完整的 URL，直接返回
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath
  }
  
  // 如果是相對路徑，添加當前域名
  if (imagePath.startsWith('/')) {
    // 獲取當前的 origin (protocol + host)
    const origin = window.location.origin
    return `${origin}${imagePath}`
  }
  
  // 如果路徑不是以 / 開頭，假設是相對於根路徑
  const origin = window.location.origin
  return `${origin}/${imagePath}`
}
